// src/components/sales/pages/sales-templates/SalesTemplatesView.jsx
import React from "react";

export default function SalesTemplatesView({ template }) {
  if (!template) {
    return (
      <div className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-4 sm:p-6 text-white/70">
        <div className="text-sm">No template selected.</div>
      </div>
    );
  }

  const templateId =
    template?.id ?? template?.templateId ?? template?.salesTemplateId ?? "-";

  const name = template?.templateName ?? template?.name ?? "-";
  const channel = template?.channelType ?? template?.channel ?? "-";
  const subject = template?.subject ?? "-";
  const content = template?.content ?? template?.body ?? "";

  const isActive =
    typeof template?.isActive === "boolean" ? template.isActive : null;

  return (
    <div className="rounded-2xl border border-white/20 bg-white/10 backdrop-blur-2xl p-4 sm:p-6 text-white shadow-[0_0_35px_rgba(255,0,255,0.12)] min-w-0">
      <div className="flex items-start justify-between gap-3 min-w-0">
        <div className="min-w-0">
          <h3 className="text-lg sm:text-xl font-semibold truncate">{name}</h3>
          <p className="text-sm text-white/60 truncate">
            Channel: <span className="text-white/80">{channel}</span> · ID:{" "}
            <span className="text-white/80">{templateId}</span>
          </p>
        </div>

        {isActive !== null && (
          <span
            className={[
              "shrink-0 rounded-full px-3 py-1 text-xs border",
              isActive
                ? "bg-emerald-500/10 border-emerald-400/30 text-emerald-300"
                : "bg-red-500/10 border-red-400/30 text-red-300",
            ].join(" ")}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        )}
      </div>

      <div className="mt-5 space-y-4 min-w-0">
        <div>
          <p className="text-xs text-white/50 mb-1">Subject</p>
          <p className="text-sm sm:text-base break-words">{subject}</p>
        </div>

        <div>
          <p className="text-xs text-white/50 mb-1">Content</p>
          <pre className="whitespace-pre-wrap break-words text-sm bg-black/30 border border-white/10 rounded-xl p-3 overflow-auto max-h-[380px]">
            {content}
          </pre>
        </div>
      </div>
    </div>
  );
}
